import React from 'react';
import PropTypes from 'prop-types';

import './style/clickableComponent.css';

export default function ClickableComponent({ onClick, children, disabled, ...props }) {
  return (
    <div
      className="clickable-wrapper"
      role="button"
      tabIndex={0}
      onKeyPress={() => null}
      onClick={disabled ? undefined : onClick}
      {...props}
    >
      {children}
    </div>
  );
}

ClickableComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

ClickableComponent.defaultProps = {
  disabled: false,
};
